import {
  SET_IS_FETCHING_SUBSCRIBERS,
  SET_SUBSCRIBERS,
  SET_IS_FETCHING_REPORT,
  SET_REPORT,
  ADD_NEW_SUBSCRIBER,
  UPDATE_REPORT,
  SET_IS_ENROLL_MODAL_OPEN,
  SET_IS_CANCELLING_SUBSCRIPTION,
  SET_ENROLL_ERROR,
  SET_QUESTIONS_LOAD_ERRORS,
  SET_QUESTIONS_ERRORS,
  SET_DARK_WEB_MODAL_ERRORS,
  SET_QUESTIONS_DATA,
  RESET_QUESTIONS_DATA,
  SET_IS_FETCHING_QUESTIONS,
  SET_SUBSCRIBER_ENROLLING,
  REMOVE_REPORT,
  REMOVE_SUBSCRIBER,
  SET_IS_ACCEPTING_TERMS,
  SET_ACCEPTING_TERMS_ERRORS,
  SET_IS_SUBMITTING_QUESTIONS,
  SET_IS_ARCHIVING_ALERT,
  SET_IS_UNARCHIVING_ALERT,
  RESET_STATE,
  SET_IS_FETCHING_DARK_WEB_DATA,
  REMOVE_BANK_ACCOUNT,
  REMOVE_CREDIT_CARD,
  ADD_NEW_CREDIT_CARD,
  ADD_NEW_BANK_ACCOUNT,
  ADD_NEW_TELEPHONE,
  REMOVE_TELEPHONE,
  ADD_NEW_EMAIL,
  REMOVE_EMAIL,
  ADD_NEW_MEDICAL_ID,
  REMOVE_MEDICAL_ID,
  ADD_NEW_PASSPORT_NUMBER,
  REMOVE_PASSPORT_NUMBER,
  ADD_NEW_IBAN,
  REMOVE_IBAN,
  ADD_NEW_DRIVER_LICENSE,
  REMOVE_DRIVER_LICENSE,
  SET_IS_FETCHING_ACTIVE_ALERTS,
  SET_IS_FETCHING_MORE_ACTIVE_ALERTS,
  SET_IS_FETCHING_ARCHIVED_ALERTS,
  SET_IS_FETCHING_MORE_ARCHIVED_ALERTS,
  ADD_ACTIVE_ALERTS,
  ADD_MORE_ACTIVE_ALERTS,
  ADD_ARCHIVED_ALERTS,
  ADD_MORE_ARCHIVED_ALERTS,
  UPDATE_ADDRESS,
  SET_SUBSCRIBERS_ERRORS,
  SET_HAS_MORE_ACTIVE_ALERTS,
  SET_HAS_MORE_ARCHIVED_ALERTS,
} from './ExperianActions';

const initialState = {
  isEnrollModalOpen: false,
  isCreditMonitoringFetched: false,
  isCancellingSubscription: false,
  isSubmittingQuestions: false,
  isFetchingReport: false,
  isFetchingSubscribers: false,
  isFetchingActiveAlerts: false,
  isFetchingArchivedAlerts: false,
  isFetchingMoreArchivedAlerts: false,
  subscriberEnrolling: '',
  enrollError: '',
  acceptingTermsErrors: [],
  questionsLoadErrors: [],
  questionsErrors: [],
  darkWebModalErrors: [],
  reports: {},
  subscribers: [],
  subscribersErrors: [],
  verificationQuestions: {
    Questions: [],
    ApplicantChallengeId: '',
  },
};

const deleteProperty = (key, obj) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { [key]: _, ...newObj } = obj;
  return newObj;
};

const experianReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_FETCHING_SUBSCRIBERS: {
      return {
        ...state,
        isFetchingSubscribers: action.payload,
      };
    }
    case SET_SUBSCRIBERS: {
      return {
        ...state,
        subscribers: action.payload,
      };
    }
    case SET_SUBSCRIBERS_ERRORS: {
      return {
        ...state,
        subscribersErrors: action.payload,
      };
    }
    case SET_IS_FETCHING_REPORT: {
      return {
        ...state,
        isFetchingReport: action.payload,
      };
    }
    case SET_REPORT: {
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: action.report,
        },
      };
    }
    case ADD_NEW_SUBSCRIBER: {
      return {
        ...state,
        subscribers: [action.payload, ...state.subscribers],
      };
    }
    case UPDATE_REPORT: {
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: action.report,
        },
      };
    }
    case REMOVE_REPORT: {
      return {
        ...state,
        reports: deleteProperty(action.payload, state.reports),
        subscribers: state.subscribers.filter(
          ({ SubscriberNumber: subscriberId }) => !(subscriberId === action.payload),
        ),
      };
    }
    case REMOVE_SUBSCRIBER: {
      return {
        ...state,
        subscribers: state.subscribers.filter(
          ({ SubscriberNumber: subscriberId }) => !(subscriberId === action.payload),
        ),
      };
    }
    case SET_SUBSCRIBER_ENROLLING: {
      return {
        ...state,
        subscriberEnrolling: action.payload,
      };
    }
    case SET_IS_ENROLL_MODAL_OPEN: {
      return {
        ...state,
        isEnrollModalOpen: action.payload,
      };
    }
    case SET_IS_CANCELLING_SUBSCRIPTION: {
      return {
        ...state,
        isCancellingSubscription: action.payload,
      };
    }
    case SET_IS_ACCEPTING_TERMS: {
      return {
        ...state,
        isAcceptingTerms: action.payload,
      };
    }
    case SET_ACCEPTING_TERMS_ERRORS: {
      return {
        ...state,
        acceptingTermsErrors: action.payload,
      };
    }
    case SET_ENROLL_ERROR: {
      return {
        ...state,
        enrollError: action.payload,
      };
    }
    case SET_QUESTIONS_LOAD_ERRORS: {
      return {
        ...state,
        questionsLoadErrors: action.payload,
      };
    }
    case SET_QUESTIONS_ERRORS: {
      return {
        ...state,
        questionsErrors: action.payload,
      };
    }
    case SET_DARK_WEB_MODAL_ERRORS: {
      return {
        ...state,
        darkWebModalErrors: action.payload,
      };
    }
    case SET_IS_FETCHING_QUESTIONS: {
      return {
        ...state,
        isFetchingQuestions: action.payload,
      };
    }
    case SET_QUESTIONS_DATA: {
      return {
        ...state,
        verificationQuestions: action.payload,
      };
    }
    case RESET_QUESTIONS_DATA: {
      return {
        ...state,
        verificationQuestions: initialState.verificationQuestions,
        questionsErrors: initialState.questionsErrors,
        questionsLoadErrors: initialState.questionsLoadErrors,
      };
    }
    case SET_IS_SUBMITTING_QUESTIONS: {
      return {
        ...state,
        isSubmittingQuestions: action.payload,
      };
    }
    case SET_IS_ARCHIVING_ALERT: {
      return {
        ...state,
        isArchivingAlert: action.payload,
      };
    }
    case SET_IS_UNARCHIVING_ALERT: {
      return {
        ...state,
        isUnarchivingAlert: action.payload,
      };
    }
    case SET_IS_FETCHING_ACTIVE_ALERTS: {
      return {
        ...state,
        isFetchingActiveAlerts: action.payload,
      };
    }
    case SET_IS_FETCHING_MORE_ACTIVE_ALERTS: {
      return {
        ...state,
        isFetchingMoreActiveAlerts: action.payload,
      };
    }
    case SET_IS_FETCHING_ARCHIVED_ALERTS: {
      return {
        ...state,
        isFetchingArchivedAlerts: action.payload,
      };
    }
    case SET_IS_FETCHING_MORE_ARCHIVED_ALERTS: {
      return {
        ...state,
        isFetchingMoreArchivedAlerts: action.payload,
      };
    }
    case SET_IS_FETCHING_DARK_WEB_DATA: {
      return {
        ...state,
        isFetchingDarkWebData: action.payload,
      };
    }
    case SET_HAS_MORE_ACTIVE_ALERTS: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            hasMoreActiveAlerts: action.hasMoreActiveAlerts,
          },
        },
      };
    }
    case SET_HAS_MORE_ARCHIVED_ALERTS: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            hasMoreArchivedAlerts: action.hasMoreArchivedAlerts,
          },
        },
      };
    }
    case ADD_NEW_BANK_ACCOUNT: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              BankAccounts: [...report.MonitoredCyberInformation.BankAccounts, action.bankAccount],
            },
          },
        },
      };
    }
    case REMOVE_BANK_ACCOUNT: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              BankAccounts: report.MonitoredCyberInformation.BankAccounts.filter(
                account => account.AccountNumberLabel !== action.accountNumberLabel,
              ),
            },
          },
        },
      };
    }
    case REMOVE_CREDIT_CARD: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              CreditCards: report.MonitoredCyberInformation.CreditCards.filter(
                account => account.CardLabel !== action.cardLabel,
              ),
            },
          },
        },
      };
    }
    case ADD_NEW_CREDIT_CARD: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              CreditCards: [...report.MonitoredCyberInformation.CreditCards, action.creditCard],
            },
          },
        },
      };
    }
    case ADD_NEW_TELEPHONE: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              TelephoneNumbers: [
                ...report.MonitoredCyberInformation.TelephoneNumbers,
                action.telephone,
              ],
            },
          },
        },
      };
    }
    case REMOVE_TELEPHONE: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              TelephoneNumbers: report.MonitoredCyberInformation.TelephoneNumbers.filter(
                tel => tel.Label !== action.telephoneLabel,
              ),
            },
          },
        },
      };
    }
    case ADD_NEW_EMAIL: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              EmailAddresses: [...report.MonitoredCyberInformation.EmailAddresses, action.email],
            },
          },
        },
      };
    }
    case REMOVE_EMAIL: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              EmailAddresses: report.MonitoredCyberInformation.EmailAddresses.filter(
                email => email.Label !== action.emailLabel,
              ),
            },
          },
        },
      };
    }
    case ADD_NEW_MEDICAL_ID: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              MedicalIds: [...report.MonitoredCyberInformation.MedicalIds, action.medicalId],
            },
          },
        },
      };
    }
    case REMOVE_MEDICAL_ID: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              MedicalIds: report.MonitoredCyberInformation.MedicalIds.filter(
                medicalId => medicalId.Label !== action.medicalIdLabel,
              ),
            },
          },
        },
      };
    }
    case ADD_NEW_IBAN: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              IBANs: [...report.MonitoredCyberInformation.IBANs, action.iban],
            },
          },
        },
      };
    }
    case REMOVE_IBAN: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              IBANs: report.MonitoredCyberInformation.IBANs.filter(
                iban => iban.Label !== action.ibanLabel,
              ),
            },
          },
        },
      };
    }
    case ADD_NEW_PASSPORT_NUMBER: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              PassportNumber: action.passportNumber,
            },
          },
        },
      };
    }
    case REMOVE_PASSPORT_NUMBER: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              PassportNumber: null,
            },
          },
        },
      };
    }
    case ADD_NEW_DRIVER_LICENSE: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              DriverLicense: action.driverLicense,
            },
          },
        },
      };
    }
    case REMOVE_DRIVER_LICENSE: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              DriverLicense: null,
            },
          },
        },
      };
    }
    case ADD_ACTIVE_ALERTS: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            ActiveAlerts: action.alerts,
          },
        },
      };
    }
    case ADD_MORE_ACTIVE_ALERTS: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            ActiveAlerts: [...report.ActiveAlerts, ...action.alerts],
          },
        },
      };
    }
    case ADD_ARCHIVED_ALERTS: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            ArchivedAlerts: action.alerts,
          },
        },
      };
    }
    case ADD_MORE_ARCHIVED_ALERTS: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            ArchivedAlerts: [...report.ArchivedAlerts, ...action.alerts],
          },
        },
      };
    }
    case UPDATE_ADDRESS: {
      const report = state.reports[action.subscriberId];
      return {
        ...state,
        reports: {
          ...state.reports,
          [action.subscriberId]: {
            ...report,
            MonitoredCyberInformation: {
              ...report.MonitoredCyberInformation,
              Address: action.address,
            },
          },
        },
      };
    }
    case RESET_STATE:
      return initialState;
    default: {
      return state;
    }
  }
};

export default experianReducer;
